import React from "react";
import { dashboardIcon } from "../../assets/img";

export const UserWallet = ({ isDataAllCard }) => {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // lighter
        borderRadius: "8px", // smaller
        height: "100%",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#222227",
            margin: 0,
          }}
        >
          User Wallet
        </p>
      </div>

      {/* Total Money */}
      <div
        style={{
          border: "1px solid #EEEEEE",
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "16px", // smaller
          padding: "14px 20px", // smaller
          marginTop: "14px", // smaller
        }}
      >
        <div>
          <p
            style={{
              fontSize: "16px", // smaller
              fontWeight: "400",
              color: "#9ca3af",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "6px", // smaller
            }}
          >
            Total Money
          </p>
          <p
            style={{
              fontSize: "22px", // smaller
              fontWeight: "bold",
              color: "#000000",
              margin: 0,
            }}
          >
            {isDataAllCard?.user_wallet?.total_money?.toFixed(2) || "0.00"}
          </p>
        </div>
        <div style={{ width: "26px", height: "26px" }}>
          <img
            src={dashboardIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      {/* Total Section */}
      <p
        style={{
          marginTop: "8px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4, // smaller
          marginTop: "8px",
        }}
      >
        {[
          {
            label: "Refre and earn",
            value: isDataAllCard?.user_wallet?.refer_and_earn_amount,
          },
          {
            label: "Reviewed amount",
            value: isDataAllCard?.user_wallet?.review_amount,
          },
          { label: "Utilized", value: isDataAllCard?.user_wallet?.utilized },
          { label: "Expired", value: isDataAllCard?.user_wallet?.expired },
          {
            label: "Cancellation Charges",
            value: isDataAllCard?.user_wallet?.cancelled_amount,
          },
          {
            label: "Money Added",
            value: isDataAllCard?.user_wallet?.money_added,
            // fullWidth: true,
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#F5F5F5",
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 10px", // smaller
              width: item.fullWidth ? "100%" : "48%",
              borderRadius: "8px", // smaller
              marginBottom: "8px", // smaller
            }}
          >
            <p style={styles.label}>{item.label}</p>
            <p style={styles.value}>{(item.value || 0).toFixed(2)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
